import React, { FunctionComponent } from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Tooltip, TooltipProps } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/InfoOutlined';

const useStylesBootstrap = makeStyles((theme: Theme) => ({
    arrow: {
        color: theme.palette.common.black,
    },
    tooltip: {
        backgroundColor: theme.palette.common.black,
        fontSize: 14,
    },
}));
const useStyles = makeStyles((theme: Theme) => ({
    childrenContainer: {
        display: 'flex',
        alignItems: 'center',
    },
    icon: {
        margin: theme.spacing(0, 1),
    },
}));
interface InfoTooltipProps extends Omit<TooltipProps, 'children'> {
    children?: React.ReactElement<any, any>;
    color?:
        | 'inherit'
        | 'primary'
        | 'secondary'
        | 'action'
        | 'disabled'
        | 'error';
}

export const InfoTooltip: FunctionComponent<InfoTooltipProps> = ({
    children,
    color = 'inherit',
    classes,
    ...rest
}) => {
    const newClasses = useStyles();
    classes = { ...classes, ...useStylesBootstrap() };
    return (
        <Tooltip arrow classes={classes} {...rest}>
            <div className={newClasses.childrenContainer}>
                {children && children}
                <InfoIcon
                    color={color}
                    focusable="true"
                    className={newClasses.icon}
                />
            </div>
        </Tooltip>
    );
};
